module.exports = __webpack_public_path__ + "img/c.dba38eca.jpg";